export const SHOP_STORE_URL = 'https://shop.alltrails.com';

export const getShopProductUrl = (handle: string): string => {
  return `${SHOP_STORE_URL}/products/${handle}`;
};

